import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Info } from "lucide-react";
 * // Use <Info /> instead
 */
export const InfoIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM11 9V7H13V9H11ZM11 17V11H13V17H11Z"
    fillRule="evenodd"
    clipRule="evenodd"
  />
);
